import { Component, OnInit, ViewChild } from '@angular/core';
import { GTopicService } from './g-topic.service';
import { Location } from '@angular/common';
import { GeneralComponent } from './g.component';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from '../shared/message.service';

export abstract class GeneralExerciseComponent extends GeneralComponent implements OnInit {


  //all exercises
  id: number;
  protected key: string;
  public solved = false;
  public isSolvedImageVisible = false;

  public type: string;

  showTip = true;
  showVideo: boolean = false;
  printable: boolean = false;

  counter = 0;
  level = 1;


  constructor(protected activatedRoute: ActivatedRoute, protected topicService: GTopicService, protected messageService: MessageService) {
    super(topicService);
  }

  /** called after the constructor */
  ngOnInit() {
    //register this exercise as current exercise
    this.topicService.registerExerise(this);


    this.id = +this.activatedRoute.snapshot.paramMap.get('id');

    //initiate the standard activities
    this.getConfiguration();
    this.setTypeSpecificsFromConfiguration();
    this.key = this.configuration.key;
    this.type = this.configuration.type;
    this.getState();
    this.setInfoFromState();
    this.setTypeSpecificsFromState();
  }

  // set solved
  setInfoFromState() {
    if (this.state['solved'] !== undefined) {
      this.solved = this.state.solved;
    }
  }

  abstract setTypeSpecificsFromConfiguration();

  abstract setTypeSpecificsFromState();

  get_title(): string {
    return this.configuration['title'];
  }

  get_description(): string {
    return this.configuration['description'];
  }

  getID(): number {
    return this.id;
  }

  /** receives the configruation from the topicService */
  getConfiguration() {
    this.configuration = this.topicService.getExerciseById(this.id);
  }
  /** receives the state from the topicService */
  getState() {
    this.state = this.topicService.getStateByKey(this.key);
  }

  /** computes the actual state and adds it to the state */
  saveState() {
    this.computeState();
    // let evaluation = this.evaluate();
    // this.state.evaluate = Math.round(evaluation[0] * 10) / 10;
    // this.state.maxPoints = Math.round(evaluation[1] * 10) / 10;
    this.topicService.setStateByKey(this.key, this.state);
    //this.messageService.addAlertWithTimeout(this.get("saveDone"), "success", 2000);
  }

  /** calls the current Exercise to reset the state */
  resetState() {
    this.topicService.resetStateByKey(this.key);
    this.solved = false;
    this.ngOnInit();
  }

  /** redirect to next exercise */
  nextClicked(): string {
    return this.topicService.nextClicked();
  }

  abstract computeState();

  abstract initValues();

  abstract checkSolution();

  abstract generateNextExercise();

  setLevel(level: number) {
    this.level = level;
  }

  // abstract evaluate(): number[];


  /** returns the key of the chapter */
  chapterType(): string {
    return this.topicService.type;
  }

  // called before printing
  preprint() { }

  // called after printing
  postprint() { }


  /**
   * Compare two arrays arr1 with arr2
   * Return true if both arrays are the same. (same length and same values in the same order)
   * @param arr1
   * @param arr2
   */
  compareArrays(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }

    return true;
  }

}
